
























































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

@Component
export default class DialogNewVenta extends Vue {
  @Prop({ type: Object })
  private info!: object

  private name: string = 'DialogNewVenta'
  private show: boolean = false
  private showBoletos: boolean = false

  private mModel: object = {
    amount: 0,
    amountDisc: 0,
    amountTotal: 0,
    discCode: '',
    discType: '',
    discValue: '',
    paymentMethod: '',
    buyerName: '',
    buyerEmail: '',
    buyerPhone: '',
    idOrder: '',
    createdAt: '',
    paidAt: null,
    boleto: []
  }

  private bModel: object = {
    amount: 0,
    amountDisc: 0,
    amountTotal: 0,
    discCode: '',
    discType: '',
    discValue: '',
    paymentMethod: '',
    buyerName: '',
    buyerEmail: '',
    buyerPhone: '',
    idOrder: '',
    createdAt: '',
    paidAt: null,
    boleto: []
  }

  private headers: any[] = [
    {
      text: 'Nombre',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Folio', value: 'folio' },
    { text: 'Encriptado', value: 'folioEncrypted' },
    { text: 'Costo', value: 'cost' }
  ]

  private discountName (discCode: any, discType: any, discValue: any) {
    let res = ''
    if (discType === '%') {
      res = discCode + ' (' + discValue + discType + ')'
    } else if (discType === '$') {
      res = discCode + ' (' + discType + discValue + ')'
    }

    return res
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    if (typeof this.info === 'object') this.mModel = this.info
  }

  @Watch('info')
  private watchInfo (v: any) {
    console.log('watchInfo :: ', v)
    if (typeof v === 'object') {
      this.mModel = Object.assign({}, v)
      this.show = true
    }
  }

  @Watch('show')
  private watchShow (v: boolean) {
    if (!v) {
      this.mModel = Object.assign({}, this.bModel)
    }
  }
}
